var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['prestrainImg', _vm.prestrainClass],style:(_vm.styleImgBox)},[(!!_vm.isShow)?_c('div',{staticClass:"img",style:(_vm.imgStyle)}):_vm._e(),_vm._t("child")],2)}
var staticRenderFns = []

export { render, staticRenderFns }